export { default } from "./CookiesConfirmation";
